import React, { Component } from 'react';
import { CostingEditor } from './CostingEditor'

export class CostingDefaults extends Component {
    static displayName = CostingDefaults.name;

    constructor(props) {
        super(props);
        this.state = { };
        
    }

 

    render() {
        return (
           <CostingEditor />
        );
    }
}